import Vue from 'vue'
import Vuex from 'vuex'

import common from './modules/common.js'
import restaurants from './modules/restaurants.js'
import platforms from './modules/platforms.js'
import licensees from './modules/licensees.js'
import contracts from './modules/contracts.js'
import invoices from './modules/invoices.js'
import reports from './modules/reports'
import sales from './modules/sales.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    common,
    licensees,
    contracts,
    restaurants,
    platforms,
    reports,
    invoices,
    sales
  }
})
